$(function () {
  // select cateogry
  var sizingCharts = {
    All: [
      // メンズ/ユニセックス
      { "mens-footwear": "メンズ/ユニセックスシューズ" },
      { "mens-shorts-pants": "メンズボトムス" },
      { "mens-back-protection": "メンズバックプロテクター" },
      { "mens-exo-tights": "メンズタイツ" },
      { "hats-caps": "ハット＆キャップ" },
      { "mens-helmets": "メンズ/ユニセックスヘルメット" },
      { "mens-shirts-tops": "メンズシャツ＆トップス" },
      { "mens-wayfarer-pants-shorts": "メンズアウトドア用ボトムス（S/R/L丈）" },
      // 共通
      { "mens-scarf-tights": "ユニセックスカーフタイツ" },
      { "running-packs": "ランニングパック" },
      { "running-belt": "ランニングベルト" },
      { "hiking-pack": "ハイキングパック" },
      { "womens-hiking-pack": "ウイメンズハイキングパック" },
      // { "caps": "キャップ" },
      { gaiter: "ゲイター" },
      { gloves: "グローブ" },
      { "snowboard-bindings": "スノーボードビンディング" },
      { "snowboard-boots": "スノーボードブーツ" },
      // ウィメンズ
      { "womens-footwear": "ウィメンズシューズ" },
      { "womens-shorts-pants": "ウィメンズボトムス" },
      { "womens-back-protection": "ウィメンズバックプロテクター" },
      { "womens-exo-tights": "ウィメンズタイツ" },
      { "womens-helmets": "ウィメンズヘルメット" },
      { "womens-shirts-tops": "ウィメンズシャツ＆トップス" },
      { "womens-sports-bras": "ウィメンズスポーツブラ" },
      {
        "womens-wayfarer-pants-shorts":
          "ウィメンズアウトドア用ボトムス（S/R/L丈）",
      },
      // キッズ
      { "kids-footwear": "キッズシューズ" },
      { "kids-back-protection": "キッズバックプロテクター" },
      { "kids-helmets": "キッズヘルメット" },
      { "kids-bindings": "キッズスノーボードビンディング" },
      // { "bags-packs": "バックパック" },
      // { "advanced-sports-bras": "スポーツブラ" },
      // { "lab-sense-packs": "S/Lab Sense Packs" },
      // { "assassin-pro-snowboard": "Assassin Pro Snowboard" },
      // { "assassin-snowboard": "Assassin Snowboard" },
      // { "craft-snowboard": "CraftSnowboard" },
      // { "dancehaul-snowboard": "Dancehaul Snowboard" },
      // { "highpath-snowboard": "Highpath Snowboard" },
      // { "highpath-split-snowboard": "Highpath Split Snowboard" },
      // { "huck-knife-pro-snowboard": "Huck Knife Pro Snowboard" },
      // { "huck-knife-snowboard": "Huck Knife Snowboard" },
      // { "pulse-snowboard": "Pulse Snowboard" },
      // { "sickstick-snowboard": "Sickstick Snowboard" },
      // { "sight-snowboard": "Sight Snowboard" },
      // { "sleepwalker-snowboard": "Sleepwalker Snowboard" },
      // { "team-package-snowboard-junior": "Team Package Snowboard Junior" },

      // { "bellevue-split-snowboard-womens": "Bellevue Split Snowboard Women's" },
      // { "lotus-snowboard-women": "Lotus Snowboard" },
      // { "no-drama-snowboard-women": "No Drama Snowboard" },
      // { "grace-snowboard-junior": "Grace Snowboard Junior" },
      // { "grail-snowboard-junior": "Grail Snowboard Junior" },
      // { "huck-knife-grom": "Huck Knife Grom" },
      // { "sleepwalker-grom-snowboards": "Sleepwalker Grom Snowboards" },
    ],
    Men: [
      { "mens-footwear": "メンズ/ユニセックスシューズ" },
      { "mens-shorts-pants": "メンズボトムス" },
      { "mens-back-protection": "メンズバックプロテクター" },
      { "mens-exo-tights": "メンズタイツ" },
      { "hats-caps": "ハット＆キャップ" },
      { "mens-helmets": "メンズ/ユニセックスヘルメット" },
      { "mens-shirts-tops": "メンズシャツ＆トップス" },
      { "mens-wayfarer-pants-shorts": "メンズアウトドア用ボトムス（S/R/L丈）" },
      { "mens-scarf-tights": "ユニセックスカーフタイツ" },
      { "running-packs": "ランニングパック" },
      { "running-belt": "ランニングベルト" },
      { "hiking-pack": "ハイキングパック" },
      // { "caps": "キャップ" },
      { gaiter: "ゲイター" },
      { gloves: "グローブ" },
      { "snowboard-bindings": "スノーボードビンディング" },
      { "snowboard-boots": "スノーボードブーツ" },
      // { "hats-caps": "ハット＆キャップ" },
      // { "lab-sense-packs": "S/Lab Sense Packs" },
      // { "assassin-pro-snowboard": "Assassin Pro Snowboard" },
      // { "assassin-snowboard": "Assassin Snowboard" },
      // { "craft-snowboard": "CraftSnowboard" },
      // { "dancehaul-snowboard": "Dancehaul Snowboard" },
      // { "highpath-snowboard": "Highpath Snowboard" },
      // { "highpath-split-snowboard": "Highpath Split Snowboard" },
      // { "huck-knife-pro-snowboard": "Huck Knife Pro Snowboard" },
      // { "huck-knife-snowboard": "Huck Knife Snowboard" },
      // { "pulse-snowboard": "Pulse Snowboard" },
      // { "sickstick-snowboard": "Sickstick Snowboard" },
      // { "sight-snowboard": "Sight Snowboard" },
      // { "sleepwalker-snowboard": "Sleepwalker Snowboard" },
      // { "team-package-snowboard-junior": "Team Package Snowboard Junior" },
      // { "oh-yea-snowboard-women": "Oh Yea Snowboard" },
      // { "rumble-fish-snowboards-women": "Rumble Fish Snowboards" },
      // { "wonder-snowboard-women": "Wonder Snowboard" },
      // { "oh-yeah-grom-snowboard": "Oh Yeah Grom Snowboard" },
    ],
    Women: [
      { "womens-footwear": "ウィメンズシューズ" },
      { "womens-shorts-pants": "ウィメンズボトムス" },
      { "womens-back-protection": "ウィメンズバックプロテクター" },
      { "womens-exo-tights": "ウィメンズタイツ" },
      { "womens-helmets": "ウィメンズヘルメット" },
      { "womens-shirts-tops": "ウィメンズシャツ＆トップス" },
      { "womens-sports-bras": "ウィメンズスポーツブラ" },
      {
        "womens-wayfarer-pants-shorts":
          "ウィメンズアウトドア用ボトムス（S/R/L丈）",
      },
      { "scarf-tights": "ユニセックスカーフタイツ" },
      { "running-packs": "ランニングパック" },
      { "running-belt": "ランニングベルト" },
      { "hiking-pack": "ハイキングパック" },
      { "womens-hiking-pack": "ウイメンズハイキングパック" },
      // { "caps": "キャップ" },
      { gaiter: "ゲイター" },
      { gloves: "グローブ" },
      { "snowboard-bindings": "スノーボードビンディング" },
      { "snowboard-boots": "スノーボードブーツ" },
      // { "bags-packs": "ウィメンズバックパック" },
      // { "advanced-sports-bras": "ウィメンズスポーツブラ" },
      // { "lab-sense-packs": "S/Lab Sense Packs" },
      // { "bellevue-split-snowboard-womens": "Bellevue Split Snowboard Women's" },
      // { "lotus-snowboard-women": "Lotus Snowboard Women" },
      // { "no-drama-snowboard-women": "No Drama Snowboard" },
      // { "oh-yea-snowboard-women": "Oh Yea Snowboard" },
      // { "rumble-fish-snowboards-women": "Rumble Fish Snowboards" },
      // { "wonder-snowboard-women": "Wonder Snowboard" },
    ],
    Kids: [
      { "kids-footwear": "キッズシューズ" },
      { "kids-back-protection": "キッズバックプロテクター" },
      { "kids-helmets": "キッズヘルメット" },
      { "kids-bindings": "キッズスノーボードビンディング" },
      // { "grace-snowboard-junior": "Grace Snowboard Junior" },
      // { "grail-snowboard-junior": "Grail Snowboard Junior" },
      // { "huck-knife-grom": "Huck Knife Grom" },
      // { "oh-yeah-grom-snowboard": "Oh Yeah Grom Snowboard" },
      // { "sleepwalker-grom-snowboards": "Sleepwalker Grom Snowboards" },
      // { "snowboard-boots": "スノーボードブーツ" },
    ],
  };
  var selectedCat = "All";
  var subCateSelctor = $("#sizing-chart__titles-select");
  $("#sizing-chart__categories-select").on("change", function () {
    selectedCat = $(this).val();
    // console.log(selectedCat);
    let { s, options } = getSubcategories(selectedCat);
    // console.log(options);
    subCateSelctor.html(options);
    if (selectedCat == "All") {
      $("#not-all").addClass("hide"); // Allの時は非表示
    } else {
      $("#not-all").removeClass("hide"); // All以外の時は表示
    }
    if (selectedCat == "All") {
      $("#Men").removeClass("hide");
      $("#Men > div").removeClass("hide");
      $("#Women").removeClass("hide");
      $("#Women  > div").removeClass("hide");
      $("#not-all").addClass("hide"); // Allの時は非表示
      $("#Kids").removeClass("hide");
      $("#Kids > div").removeClass("hide");

      $("#Men").addClass("show");
      $("#Women").addClass("show");
      $("#Kids").addClass("show");
    } else {
      $("#not-all").removeClass("hide"); // All以外の時は表示
      $(".sizing-chart-main > div").addClass("hide");
      $(`#${selectedCat}`).removeClass("hide");
      $(`#${selectedCat}`).addClass("show");
      $(`#${selectedCat} > div`).addClass("show");
      $(`#${selectedCat} > div`).removeClass("hide");
    }
  });

  // set options key value onchange category
  let { subcategories, options } = getSubcategories(selectedCat);
  subCateSelctor.html(options);

  var selectedSubcat = "";
  $("#sizing-chart__titles-select").on("change", function () {
    $(`.sizing-chart__tables-group`).addClass("hide");
    selectedSubcat = $(this).val();
    let { subcategories } = getSubcategories(
      $("#sizing-chart__categories-select").val()
    );
    if (subcategories.includes(selectedSubcat)) {
      $(`.sizing-chart__tables-group[data-table=${selectedSubcat}]`).addClass(
        "show"
      );
      $(
        `.sizing-chart__tables-group[data-table=${selectedSubcat}]`
      ).removeClass("hide");
    } else {
      $(`.sizing-chart__tables-group`).removeClass("hide");
    }
  });

  function getSubcategories(selectedCat) {
    var subcategories = [];
    let options = "<option value=''>choose a product's category</option>";
    $.each(sizingCharts[selectedCat], function (key, value) {
      let optionValue = Object.keys(value)[0];
      let optionText = Object.values(value)[0];
      options +=
        "<option data-category=" +
        selectedCat +
        " value=" +
        optionValue +
        ">" +
        optionText +
        "</option>";
      subcategories.push(optionValue);
    });

    return { subcategories, options };
  }

  function switchUnit() {
    const active = $(this).data("active");
    $(this).prev().prev().children(".table--in").removeClass("show hide");
    $(this).prev().prev().children(".table--cm").removeClass("show hide");

    if (active == "cm") {
      $(this).data("active", "in");
      $(this).removeClass(selectors.cmActive);
      $(this).addClass(selectors.inActive);
      $(this).prev().prev().removeClass(selectors.cmActive);
      $(this).prev().prev().addClass(selectors.inActive);
      if ($(this).prev().prev().children().hasClass("table--in")) {
        $(this).prev().prev().children(".table--in").addClass("show");
        $(this).prev().prev().children(".table--cm").addClass("hide");
      }
    } else {
      $(this).data("active", "cm");
      $(this).removeClass(selectors.inActive);
      $(this).addClass(selectors.cmActive);
      $(this).prev().prev().removeClass(selectors.inActive);
      $(this).prev().prev().addClass(selectors.cmActive);
      if ($(this).prev().prev().children().hasClass("table--cm")) {
        $(this).prev().prev().children(".table--cm").addClass("show");
        $(this).prev().prev().children(".table--in").addClass("hide");
      }
    }
  }
  function switchAll() {
    const active = $(this).data("active");
    if (active == "cm") {
      $(this).data("active", "in");
      $(this).removeClass(selectors.cmActive);
      $(this).addClass(selectors.inActive);
    } else {
      $(this).data("active", "cm");
      $(this).removeClass(selectors.inActive);
      $(this).addClass(selectors.cmActive);
    }
    $(selectors.unitButtonSingle).each(function (index) {
      if ($(this).data("active") == active) {
        $(this)
          .delay(100 * index)
          .queue(function () {
            $(this).click().dequeue();
          });
      }
    });
  }

  var selectors = {
    unitButtonSingle: ".unit-button.unit-button--single",
    unitButtonAll: ".unit-button.unit-button--all",
    unitTableContainer: ".unit-table-container",
    cmActive: "cm-active",
    inActive: "in-active",
    category: "#sizing-chart__categories-select",
  };
  $(selectors.unitButtonSingle).on("click", switchUnit);
  $(selectors.unitButtonAll).on("click", switchAll);
});
